import { Toast, type ToastComponent } from '@opallabs/lapidary'

export const UploadInvalidToast: ToastComponent = (toastProps) => (
  <Toast
    {...toastProps}
    message={`Sorry, none of the files you added are supported.`}
    title="Unable to Upload"
  />
)
